import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import UrlField from 'ContentComponents/components/cmv2/fields/Url';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import UrlTypes from 'ContentUtils/enums/UrlTypes';
import { REL_TYPES } from 'ContentUtils/constants/Link';
import withPartials from 'ContentComponents/components/cmv2/decorators/withPartials';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.link.${key}`;
const DEFAULT_VALUE = {
  url: {
    type: UrlTypes.EXTERNAL,
    href: ''
  },
  open_in_new_tab: false,
  no_follow: false
};
class LinkField extends Component {
  constructor(props) {
    super(props);
    this.onUrlDataChange = this.onUrlDataChange.bind(this);
    this.onPropertyChange = this.onPropertyChange.bind(this);
  }
  get fieldKey() {
    const {
      fieldKey
    } = this.props;
    return fieldKey && fieldKey.join('.');
  }
  onUrlDataChange(url) {
    const {
      onFieldChange,
      value = Object.assign({}, DEFAULT_VALUE)
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      url
    }));
  }
  onPropertyChange(key, evt) {
    const {
      onFieldChange,
      value = Object.assign({}, DEFAULT_VALUE)
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      [key]: evt.target.checked
    }));
  }
  renderToggle(key) {
    const {
      partial,
      readOnly,
      value = Object.assign({}, DEFAULT_VALUE)
    } = this.props;
    const checked = value && value[key];
    return /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(FormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`toggles.${key}.label`)
        })
      }), /*#__PURE__*/_jsx(Toggle, {
        "data-toggle": key,
        "data-checked": checked,
        checked: checked,
        id: key,
        onChange: partial(this.onPropertyChange, key),
        readOnly: readOnly,
        size: "extra-small"
      })]
    });
  }
  renderRelOptions() {
    const {
      partial,
      readOnly,
      show_advanced_rel_options = false,
      value = Object.assign({}, DEFAULT_VALUE)
    } = this.props;
    return Object.keys(REL_TYPES).map(key => {
      const rel = REL_TYPES[key];
      const checked = !!(value && value[rel]);
      const isAdvancedRelOption = rel === REL_TYPES.SPONSORED || rel === REL_TYPES.UGC;
      if (!show_advanced_rel_options && isAdvancedRelOption) {
        return null;
      }
      return /*#__PURE__*/_jsx(Checkbox, {
        checked: checked,
        id: `${this.fieldKey}-${rel}`,
        onChange: partial(this.onPropertyChange, rel),
        readOnly: readOnly,
        size: "small",
        children: /*#__PURE__*/_jsx(View, {
          "data-toggle": rel,
          "data-checked": checked,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`toggles.${rel}.label`)
          })
        })
      }, rel);
    });
  }
  render() {
    const {
      componentsByType,
      error = false,
      fieldKey,
      pageContext = {},
      placeholder,
      readOnly,
      required,
      supported_types,
      useOnDark,
      value = Object.assign({}, DEFAULT_VALUE)
    } = this.props;
    const url = value && value.url || DEFAULT_VALUE.url;
    const isCallToActionSelected = value && value.url && value.url.type === UrlTypes.CALL_TO_ACTION;
    const relTooltip = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('toggles.tooltip_jsx'),
      elements: {
        Link
      },
      options: {
        href: 'https://knowledge.hubspot.com/website-pages/insert-a-link-in-a-rich-text-module#customize-your-link-s-attributes-optional'
      }
    });
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormControl, {
        children: /*#__PURE__*/_jsx(UrlField, {
          error: error,
          fieldKey: fieldKey,
          onFieldChange: this.onUrlDataChange,
          placeholder: placeholder,
          value: url,
          supported_types: supported_types,
          readOnly: readOnly,
          required: required,
          componentsByType: componentsByType,
          useOnDark: useOnDark,
          pageContext: pageContext
        })
      }), !isCallToActionSelected && /*#__PURE__*/_jsx(FormControl, {
        children: this.renderToggle('open_in_new_tab')
      }), !isCallToActionSelected && /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('toggles.label')
        }),
        tooltip: relTooltip,
        marginBlockStart: "0",
        children: /*#__PURE__*/_jsx(ToggleGroup, {
          name: this.fieldKey,
          children: this.renderRelOptions()
        })
      })]
    });
  }
}
export default withPartials()(LinkField);